import React, { useRef } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './Components/Navbar';
import SlidingImage from './Components/SlidingImage';
import AboutUs from './Components/AboutUs';
import { OurServices } from './Components/OurServices';
import ProductList from './Components/ProductList';
import Clients from './Components/Clients';
import Gallery from './Components/Gallery';
import Footer from './Components/Footer';
import ProductInfo from './Components/ProductInfo';
import Enquiry from './Components/Enquiry';
import Cart from './Components/Cart';
import { CartProvider } from './Context/CartContext';
import { Box } from '@mui/material';

function App() {
  const productsRef = useRef(null);
  const aboutUsRef = useRef(null);
  const enquiryRef = useRef(null);
  const clientsRef = useRef(null);
  const footerRef = useRef(null);

  const handleScrollToProducts = () => {
    productsRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleScrollToAboutUs = () => {
    aboutUsRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleScrollToEnquiry = () => {
    enquiryRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleScrollToClients = () => {
    clientsRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleScrollToFooter = () => {
    footerRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <CartProvider>
      <Router>
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <Navbar
            productsRef={productsRef}
            aboutUsRef={aboutUsRef}
            enquiryRef={enquiryRef}
            clientsRef={clientsRef}
          />
          <Box sx={{ flex: 1 }}>
            <Routes>
              <Route path="/" element={
                <>
                  <SlidingImage />
                  <div ref={productsRef}>
                    <ProductList />
                  </div>
                  <div ref={aboutUsRef}>
                    <AboutUs />
                  </div>
                  <OurServices
                    onContactClick={handleScrollToFooter}
                    onDicussionClick={handleScrollToEnquiry}
                    onQuotationClick={handleScrollToEnquiry}
                    onProductionClick={handleScrollToAboutUs}
                  />
                  <div ref={clientsRef}>
                    <Clients />
                  </div>
                  <div ref={enquiryRef}>
                    <Enquiry />
                  </div>
                  <Gallery />
                </>
              } />
              <Route path="/ProductInfo/:productId" element={<ProductInfo />} />
              <Route path="/Enquiry" element={<div ref={enquiryRef}><Enquiry /></div>} />
              <Route path="/AboutUs" element={<AboutUs />} />
              <Route path="/Products" element={<ProductList />} />
              <Route path="/OurClients" element={<Clients />} />
              <Route path="/Cart" element={<Cart />} />
            </Routes>
          </Box>
          <div ref={footerRef}>
            <Footer
              onHomeClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              onAboutClick={handleScrollToAboutUs}
              onContactClick={handleScrollToFooter}
            />
          </div>
        </Box>
      </Router>
    </CartProvider>
  );
}

export default App;
